import { z } from "zod";
import { REQUISITION_STATUS_NAMES } from "@/features/recruitment/requisition-vocabulary";

/**
 * Search params for the two governance routes.
 *
 * Each route owns its own keys. Before P4 both tables read `reqQ` / `reqStatus`
 * / `planQ` off the recruitment route because they were tabs on it, and the
 * components kept doing that after the split: `getRouteApi(recruitment.id)
 * .useSearch()` throws "Could not find an active match" the moment it runs on
 * a route that is not the one it names, so both pages white-screened. The
 * search key belongs to the route that renders it, and the filter reaches the
 * component as a prop.
 *
 * The keys keep their old names so a bookmark saved from the five-tab page
 * still restores the filter it was pointing at.
 */
export const recruitmentRequisitionsSearchSchema = z.object({
  /// Free-text match on role, matched by the shore against the requisition's
  /// designation.
  reqQ: z.string().optional(),
  /// Status filter, over the same vocabulary the table's own dropdown offers.
  /// The enum is shared with `requisitions-table.tsx` rather than restated, so
  /// a status the dropdown can select is always one this route can parse.
  reqStatus: z.enum(REQUISITION_STATUS_NAMES).optional(),
});

export const recruitmentStaffingPlansSearchSchema = z.object({
  planQ: z.string().optional(),
});

export type RecruitmentRequisitionsSearch = z.infer<typeof recruitmentRequisitionsSearchSchema>;
export type RecruitmentStaffingPlansSearch = z.infer<typeof recruitmentStaffingPlansSearchSchema>;
